import { Employee } from '../types';

export const employeeData: Employee[] = [
  {
    id: 1,
    name: "Brown, Janice",
    location: "Bean Station",
    department: "PT",
    isActive: true,
    hourlyRate: 28.50,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2280.00,
    taxes: 58.60,
    totalPay: 2530.68
  },
  {
    id: 2,
    name: "Kirk, Kesley",
    location: "Morristown",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2981.60,
    calculatedPay: 2981.60,
    taxes: 76.63,
    totalPay: 3310.17
  },
  {
    id: 3,
    name: "Widener, Christine D",
    location: "Bean Station",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 14.00,
    hoursWorked: 75.00,
    salary: null,
    calculatedPay: 1050.00,
    taxes: 26.99,
    totalPay: 1165.71
  },
  {
    id: 4,
    name: "Fowler, Andrew",
    location: "Jefferson City",
    department: "PT",
    isActive: false,
    hourlyRate: 27.60,
    hoursWorked: 30.00,
    salary: null,
    calculatedPay: 0.00,
    taxes: 0.00,
    totalPay: 0.00
  },
  {
    id: 5,
    name: "Harris, Logan T",
    location: "Jefferson City",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2992.31,
    calculatedPay: 2992.31,
    taxes: 76.90,
    totalPay: 3322.06
  },
  {
    id: 6,
    name: "Misenheimer, Madison L",
    location: "Jefferson City",
    department: "OT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3129.81,
    calculatedPay: 3129.81,
    taxes: 80.44,
    totalPay: 3474.72
  },
  {
    id: 7,
    name: "Cox, Chandler L",
    location: "Jefferson City",
    department: "PTA",
    isActive: true,
    hourlyRate: 25.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2000.00,
    taxes: 51.40,
    totalPay: 2220.40
  },
  {
    id: 8,
    name: "Turner, Heather",
    location: "Jefferson City",
    department: "COTA",
    isActive: true,
    hourlyRate: 18.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1440.00,
    taxes: 37.01,
    totalPay: 1598.69
  },
  {
    id: 9,
    name: "Shaffer, Kristyn",
    location: "Jefferson City",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 16.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1280.00,
    taxes: 32.90,
    totalPay: 1421.06
  },
  {
    id: 10,
    name: "Wyman, Travis",
    location: "Jefferson City",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 800.00,
    taxes: 20.56,
    totalPay: 888.16
  },
  {
    id: 11,
    name: "Free, Kassondra",
    location: "Marketing",
    department: "Marketing",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3653.85,
    calculatedPay: 3653.85,
    taxes: 93.90,
    totalPay: 4056.50
  },
  {
    id: 12,
    name: "Vaughn, Christina",
    location: "Marketing",
    department: "Marketing",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2307.69,
    calculatedPay: 2307.69,
    taxes: 59.31,
    totalPay: 2562.00
  },
  {
    id: 13,
    name: "Bonk, Kristen M",
    location: "Maryville",
    department: "PT",
    isActive: true,
    hourlyRate: 56.24,
    hoursWorked: 50.00,
    salary: null,
    calculatedPay: 2812.00,
    taxes: 72.27,
    totalPay: 3121.88
  },
  {
    id: 14,
    name: "Straquadine, Emily",
    location: "Maryville",
    department: "PT",
    isActive: true,
    hourlyRate: 30.16,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2412.80,
    taxes: 62.01,
    totalPay: 2678.69
  },
  {
    id: 15,
    name: "Losurdo, Mari",
    location: "Maryville",
    department: "OT",
    isActive: true,
    hourlyRate: 20.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1600.00,
    taxes: 41.12,
    totalPay: 1776.32
  },
  {
    id: 16,
    name: "Neely, Caitlin",
    location: "Maryville",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3350.00,
    calculatedPay: 3350.00,
    taxes: 86.10,
    totalPay: 3719.17
  },
  {
    id: 17,
    name: "Gray, Keri",
    location: "Maryville",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 16.00,
    hoursWorked: 60.00,
    salary: null,
    calculatedPay: 960.00,
    taxes: 24.67,
    totalPay: 1065.79
  },
  {
    id: 18,
    name: "Hassenplug, Brittney",
    location: "Maryville",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 64.00,
    salary: null,
    calculatedPay: 640.00,
    taxes: 16.45,
    totalPay: 710.53
  },
  {
    id: 19,
    name: "Kaley Maynard",
    location: "Maryville",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 20.00,
    salary: null,
    calculatedPay: 200.00,
    taxes: 5.14,
    totalPay: 222.04
  },
  {
    id: 20,
    name: "Weir, Ethan",
    location: "Maryville",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 30.00,
    salary: null,
    calculatedPay: 300.00,
    taxes: 7.71,
    totalPay: 333.06
  },
  {
    id: 21,
    name: "Duncan, Renee",
    location: "Morristown",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2307.69,
    calculatedPay: 2307.69,
    taxes: 59.31,
    totalPay: 2562.00
  },
  {
    id: 22,
    name: "Cole, Hannah",
    location: "Morristown",
    department: "OT",
    isActive: true,
    hourlyRate: 19.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1520.00,
    taxes: 39.06,
    totalPay: 1687.50
  },
  {
    id: 23,
    name: "Jones, Jamie",
    location: "Morristown",
    department: "PTA",
    isActive: true,
    hourlyRate: 25.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2000.00,
    taxes: 51.40,
    totalPay: 2220.40
  },
  {
    id: 24,
    name: "Loop, Heather R",
    location: "Morristown",
    department: "COTA",
    isActive: true,
    hourlyRate: 18.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1440.00,
    taxes: 37.01,
    totalPay: 1598.69
  },
  {
    id: 25,
    name: "Patel, Sohini",
    location: "Morristown",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 14.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1120.00,
    taxes: 28.78,
    totalPay: 1243.42
  },
  {
    id: 26,
    name: "Posey, Annamaria",
    location: "Morristown",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 13.00,
    hoursWorked: 72.00,
    salary: null,
    calculatedPay: 936.00,
    taxes: 24.06,
    totalPay: 1039.15
  },
  {
    id: 27,
    name: "Warren, Terry l",
    location: "Morristown",
    department: "PT",
    isActive: true,
    hourlyRate: 29.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2320.00,
    taxes: 59.62,
    totalPay: 2575.66
  },
  {
    id: 28,
    name: "Moore, Nicholas",
    location: "Jefferson City",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3800.00,
    calculatedPay: 3800.00,
    taxes: 97.66,
    totalPay: 4218.76
  },
  {
    id: 29,
    name: "Newberry, Donnie",
    location: "Newport",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3961.54,
    calculatedPay: 3961.54,
    taxes: 101.81,
    totalPay: 4398.10
  },
  {
    id: 30,
    name: "Rhoton, Madison",
    location: "Morristown",
    department: "COTA",
    isActive: true,
    hourlyRate: 18.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1440.00,
    taxes: 37.01,
    totalPay: 1598.69
  },
  {
    id: 31,
    name: "Zuger, Emma",
    location: "Morristown",
    department: "Technician",
    isActive: true,
    hourlyRate: 12.00,
    hoursWorked: 65.00,
    salary: null,
    calculatedPay: 780.00,
    taxes: 20.05,
    totalPay: 865.96
  },
  {
    id: 32,
    name: "Claire Plunkit",
    location: "Maryville",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3192.31,
    calculatedPay: 3192.31,
    taxes: 82.04,
    totalPay: 3544.10
  },
  {
    id: 33,
    name: "Anna Searles",
    location: "Morristown",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 16.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1280.00,
    taxes: 32.90,
    totalPay: 1421.06
  },
  {
    id: 34,
    name: "Michelle Jessie",
    location: "Bean Station",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 16.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1280.00,
    taxes: 32.90,
    totalPay: 1421.06
  },
  {
    id: 35,
    name: "Miller, Kaiden",
    location: "Morristown",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2800.00,
    calculatedPay: 2800.00,
    taxes: 71.96,
    totalPay: 3108.56
  },
  {
    id: 36,
    name: "Cole, Jessica",
    location: "Morristown",
    department: "OT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2826.92,
    calculatedPay: 2826.92,
    taxes: 72.65,
    totalPay: 3138.45
  },
  {
    id: 37,
    name: "Harris, Rachel",
    location: "Morristown",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2992.31,
    calculatedPay: 2992.31,
    taxes: 76.90,
    totalPay: 3322.06
  },
  {
    id: 38,
    name: "Garland, Madison L",
    location: "New Tazewell",
    department: "COTA",
    isActive: true,
    hourlyRate: 18.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1440.00,
    taxes: 37.01,
    totalPay: 1598.69
  },
  {
    id: 39,
    name: "Daniels, Brittany",
    location: "New Tazewell",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 15.00,
    hoursWorked: 60.87,
    salary: null,
    calculatedPay: 913.05,
    taxes: 23.47,
    totalPay: 1013.67
  },
  {
    id: 40,
    name: "Brooks, Barry",
    location: "New Tazewell",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 47.33,
    salary: null,
    calculatedPay: 473.30,
    taxes: 12.16,
    totalPay: 525.46
  },
  {
    id: 41,
    name: "Bunch, Crislyn",
    location: "New Tazewell",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 28.02,
    salary: null,
    calculatedPay: 280.20,
    taxes: 7.20,
    totalPay: 311.08
  },
  {
    id: 42,
    name: "Nelson, Stephen",
    location: "Newport",
    department: "PT",
    isActive: true,
    hourlyRate: 26.27,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2101.60,
    taxes: 54.01,
    totalPay: 2333.20
  },
  {
    id: 43,
    name: "Gilbert, Caleb",
    location: "Morristown",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 16.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1280.00,
    taxes: 32.90,
    totalPay: 1421.06
  },
  {
    id: 44,
    name: "Rinehardt, Lani",
    location: "Bean Station",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2692.31,
    calculatedPay: 2692.31,
    taxes: 69.19,
    totalPay: 2989.00
  },
  {
    id: 45,
    name: "Nohren, Chase",
    location: "Jefferson City",
    department: "PTA",
    isActive: true,
    hourlyRate: 26.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2080.00,
    taxes: 53.46,
    totalPay: 2309.22
  },
  {
    id: 46,
    name: "Miller, Emily",
    location: "Newport",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 70.00,
    salary: null,
    calculatedPay: 700.00,
    taxes: 17.99,
    totalPay: 777.14
  },
  {
    id: 47,
    name: "Smith, Janet",
    location: "Newport",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 15.00,
    hoursWorked: 72.00,
    salary: null,
    calculatedPay: 1080.00,
    taxes: 27.76,
    totalPay: 1199.02
  },
  {
    id: 48,
    name: "Bradley, Lora",
    location: "Rogersville",
    department: "PT",
    isActive: true,
    hourlyRate: 28.08,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2246.40,
    taxes: 57.73,
    totalPay: 2493.95
  },
  {
    id: 49,
    name: "Miller, Andrew",
    location: "Rogersville",
    department: "PTA",
    isActive: true,
    hourlyRate: 23.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1840.00,
    taxes: 47.29,
    totalPay: 2042.77
  },
  {
    id: 50,
    name: "Keener, Emily",
    location: "Rogersville",
    department: "OT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2115.38,
    calculatedPay: 2115.38,
    taxes: 54.37,
    totalPay: 2348.49
  },
  {
    id: 51,
    name: "Henegar, Hope",
    location: "Rogersville",
    department: "COTA",
    isActive: true,
    hourlyRate: 18.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1440.00,
    taxes: 37.01,
    totalPay: 1598.69
  },
  {
    id: 52,
    name: "Rich, Renee",
    location: "Rogersville",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3158.70,
    calculatedPay: 3158.70,
    taxes: 81.18,
    totalPay: 3506.79
  },
  {
    id: 53,
    name: "Runions, Jacob",
    location: "New Tazewell",
    department: "PT",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3250.77,
    calculatedPay: 3250.77,
    taxes: 83.54,
    totalPay: 3609.00
  },
  {
    id: 54,
    name: "Collier, Rachel",
    location: "Rogersville",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 12.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 960.00,
    taxes: 24.67,
    totalPay: 1065.79
  },
  {
    id: 55,
    name: "Ricker, Jerry",
    location: "Rogersville",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 35.10,
    salary: null,
    calculatedPay: 351.00,
    taxes: 9.02,
    totalPay: 389.68
  },
  {
    id: 56,
    name: "Reece, Elizabeth",
    location: "Admin",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3794.42,
    calculatedPay: 3794.42,
    taxes: 97.52,
    totalPay: 4212.57
  },
  {
    id: 57,
    name: "Gibson, Ryan",
    location: "Admin",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2971.15,
    calculatedPay: 2971.15,
    taxes: 76.36,
    totalPay: 3298.57
  },
  {
    id: 58,
    name: "Harkleroad, Madisyn S",
    location: "",
    department: "Other",
    isActive: true,
    hourlyRate: 22.50,
    hoursWorked: 33.00,
    salary: null,
    calculatedPay: 742.50,
    taxes: 19.08,
    totalPay: 824.32
  },
  {
    id: 59,
    name: "King, Barbara",
    location: "Admin",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2307.69,
    calculatedPay: 2307.69,
    taxes: 59.31,
    totalPay: 2562.00
  },
  {
    id: 60,
    name: "Vaughn, Glenn H",
    location: "",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2769.23,
    calculatedPay: 2769.23,
    taxes: 71.17,
    totalPay: 3074.40
  },
  {
    id: 61,
    name: "Wright, Kirsten R",
    location: "Admin",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3611.20,
    calculatedPay: 3611.20,
    taxes: 92.81,
    totalPay: 4009.15
  },
  {
    id: 62,
    name: "Atkins, Debbie",
    location: "Billing",
    department: "Billing",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 2884.62,
    calculatedPay: 2884.62,
    taxes: 74.13,
    totalPay: 3202.51
  },
  {
    id: 63,
    name: "Black, Elliott",
    location: "",
    department: "Other",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 532.69,
    calculatedPay: 532.69,
    taxes: 13.69,
    totalPay: 591.39
  },
  {
    id: 64,
    name: "Black, Emmett",
    location: "",
    department: "Other",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 532.69,
    calculatedPay: 532.69,
    taxes: 13.69,
    totalPay: 591.39
  },
  {
    id: 65,
    name: "Black, Eric",
    location: "Admin",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 1923.08,
    calculatedPay: 1923.08,
    taxes: 49.42,
    totalPay: 2135.00
  },
  {
    id: 66,
    name: "Black, Jordan",
    location: "",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 6923.08,
    calculatedPay: 6923.08,
    taxes: 177.92,
    totalPay: 7686.00
  },
  {
    id: 67,
    name: "Greenlee, Anna A",
    location: "Billing",
    department: "Billing",
    isActive: true,
    hourlyRate: 25.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2000.00,
    taxes: 51.40,
    totalPay: 2220.40
  },
  {
    id: 68,
    name: "Hall, Kellie M",
    location: "Billing",
    department: "Billing",
    isActive: true,
    hourlyRate: 18.52,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1481.60,
    taxes: 38.08,
    totalPay: 1644.87
  },
  {
    id: 69,
    name: "",
    location: "Admin",
    department: "Other",
    isActive: false,
    hourlyRate: null,
    hoursWorked: null,
    salary: null,
    calculatedPay: 0.00,
    taxes: 0.00,
    totalPay: 0.00
  },
  {
    id: 70,
    name: "Watson, Tanner",
    location: "Bean Station",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 60.00,
    salary: null,
    calculatedPay: 600.00,
    taxes: 15.42,
    totalPay: 666.12
  },
  {
    id: 71,
    name: "Flynn, Nicky",
    location: "Billing",
    department: "Billing",
    isActive: true,
    hourlyRate: 20.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1600.00,
    taxes: 41.12,
    totalPay: 1776.32
  },
  {
    id: 72,
    name: "George Durham",
    location: "New Tazewell",
    department: "PT",
    isActive: true,
    hourlyRate: 29.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 2320.00,
    taxes: 59.62,
    totalPay: 2575.66
  },
  {
    id: 73,
    name: "Jeremy Cook",
    location: "Rogersville",
    department: "Leadership Team",
    isActive: true,
    hourlyRate: null,
    hoursWorked: null,
    salary: 3846.15,
    calculatedPay: 3846.15,
    taxes: 98.85,
    totalPay: 4270.00
  },
  {
    id: 74,
    name: "Grooms, Hannah",
    location: "Bean Station",
    department: "Front Desk",
    isActive: true,
    hourlyRate: 16.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 1280.00,
    taxes: 32.90,
    totalPay: 1421.06
  },
  {
    id: 75,
    name: "Walker, Katherine",
    location: "Bean Station",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 50.00,
    salary: null,
    calculatedPay: 500.00,
    taxes: 12.85,
    totalPay: 555.10
  },
  {
    id: 76,
    name: "Grebe, Morgan",
    location: "Morristown",
    department: "PT",
    isActive: true,
    hourlyRate: 36.00,
    hoursWorked: 45.00,
    salary: null,
    calculatedPay: 1620.00,
    taxes: 41.63,
    totalPay: 1798.52
  },
  {
    id: 77,
    name: "Walts, Helena",
    location: "Morristown",
    department: "Technician",
    isActive: true,
    hourlyRate: 12.00,
    hoursWorked: 40.00,
    salary: null,
    calculatedPay: 480.00,
    taxes: 12.34,
    totalPay: 532.90
  },
  {
    id: 78,
    name: "Bradley, Chloe",
    location: "Rogersville",
    department: "Technician",
    isActive: true,
    hourlyRate: 10.00,
    hoursWorked: 20.00,
    salary: null,
    calculatedPay: 200.00,
    taxes: 5.14,
    totalPay: 222.04
  },
  {
    id: 79,
    name: "Kennedy, Hunter",
    location: "Jefferson City",
    department: "Technician",
    isActive: true,
    hourlyRate: 11.00,
    hoursWorked: 80.00,
    salary: null,
    calculatedPay: 880.00,
    taxes: 22.62,
    totalPay: 976.98
  }
];

export const availableLocations = [
  "",
  "Admin",
  "Billing",
  "Marketing",
  "Morristown",
  "Bean Station",
  "New Tazewell",
  "Maryville",
  "Newport",
  "Rogersville",
  "Jefferson City"
];

export const availableDepartments = [
  "Leadership Team",
  "Billing",
  "Front Desk",
  "Referral Dept.",
  "Marketing",
  "PT",
  "OT",
  "PTA",
  "COTA",
  "Technician",
  "Other"
];

// Tax rate for calculation
export const TAX_RATE = 0.0257; // 2.57%
export const BENEFITS_RATE = 0.08; // 8%